import { render } from "./WritingAnswer.vue?vue&type=template&id=15e7531d&scoped=true&ts=true"
import script from "./WritingAnswer.vue?vue&type=script&lang=ts"
export * from "./WritingAnswer.vue?vue&type=script&lang=ts"

import "./WritingAnswer.vue?vue&type=style&index=0&id=15e7531d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e7531d"]])

export default __exports__